import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
const NO_KEYS = [];
export const useAPIKeys = (param)=>{
    let { sort } = param;
    var _ref;
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.APIKeys,
            sort.field,
            sort.direction
        ],
        queryFn: ()=>api.business.getAPIKeys({
                sortBy: sort.field,
                sortDirection: sort.direction
            })
    });
    return {
        keys: (_ref = data === null || data === void 0 ? void 0 : data.keys) !== null && _ref !== void 0 ? _ref : NO_KEYS,
        isLoading,
        hasError: error != null,
        refresh
    };
};
